import { Input, Typography } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { formatoMonedaGenerico } from '../utils/converters';
import CurrencyInputCustom from './CurrencyInputCustom';
/*
 Componente que maneja montos de configuracion, tiene 2 opciones: Multimonedas (CurrencyInputCustom) o Input (String, Porcentaje)
 Los valores -1 y 0 corresponde a Excluye/Incluye
 */

const EditableInputField = ({
  editable,
  onChange,
  value,
  moneda,
  mostrarIncluye,
  options,
  style = {},
  ...props
}) => {
  // console.log(editable);
  const [isNumber, setIsNumber] = useState(false);

  const conDecimalesString = useCallback(
    (val) => {
      if (options) {
        const newValue = `${val}`;
        const sinAgrupar = newValue.replaceAll(options.groupSeparator, '');
        const conDecimales = sinAgrupar.replaceAll(
          options.decimalSeparator,
          '.'
        );
        return conDecimales;
      }
      return val;
    },
    [options]
  );

  const handleChange = (val) => {
    const conDecimales = conDecimalesString(val);
    onChange(conDecimales);
  };

  useEffect(() => {
    if (options) {
      let isNumberValue = false;
      if (value === undefined) {
        isNumberValue = false;
      } else if (value === -3 || value === '-3') {
        isNumberValue = true;
      } else if (value) {
        const conDecimales = conDecimalesString(value);
        const conDecimalesNumber = Number(conDecimales);
        isNumberValue = !Number.isNaN(conDecimalesNumber); // && conDecimalesNumber > 0;
      }
      setIsNumber(isNumberValue);
    }
  }, [value, options, conDecimalesString]);

  const finalValue = value;
  // finalValue = value === -3 || value === '-3' ? '100%' : value || '100%';
  // if (value === '0') {
  //   finalValue = 'Incluye';
  // }

  let content;

  if (editable) {
    if (isNumber) {
      content = (
        <CurrencyInputCustom
          onChange={handleChange} // Maneja value
          value={value === -3 || value === '-3' ? '' : value}
          moneda={moneda}
          suffixActions={props.suffix}
          style={style}
          readOnly={props.readOnly}
          options={options}
        />
      );
    } else {
      content = (
        <Input
          value={finalValue}
          onChange={onChange}
          className="editable-input"
          bordered={false}
          style={{
            ...style,
            width: 'auto',
            padding: 0,
            textAlign: 'right'
          }}
          {...props}
          readOnly
        />
      );
    }
  } else if (isNumber) {
    content = (
      <Typography.Text>
        {formatoMonedaGenerico(moneda, finalValue)}
      </Typography.Text>
    );
  } else {
    content = <Typography.Text>{finalValue}</Typography.Text>;
  }

  return <>{content}</>;
};

export default EditableInputField;
